import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import MobileNav from './MobileNav';
import TrialBanner from '../ui/TrialBanner';
import TrialExpiredModal from '../TrialExpiredModal';
import SignalPopup from '../signals/SignalPopup';
import InstallPrompt from '../ui/InstallPrompt';
import PushPermissionPrompt from '../notifications/PushPermissionPrompt';
import type { Signal } from '@trading/shared';

export default function Layout() {
  const navigate = useNavigate();
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  const handleSignalClick = (_signal: Signal) => {
    navigate('/signals');
  };

  return (
    <div className="min-h-screen bg-bg-primary flex">
      {/* Sidebar — sticky on desktop, slide-in drawer on mobile */}
      <Sidebar
        mobileOpen={mobileNavOpen}
        onMobileClose={() => setMobileNavOpen(false)}
      />

      {/* Main column */}
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar onMenuClick={() => setMobileNavOpen(true)} />
        <TrialBanner />

        {/* Full-bleed: every authenticated page fills the viewport (better use
            of large/4K monitors). Public/legal pages live outside this shell. */}
        <main className="flex-1 px-4 sm:px-6 py-6 pb-24 md:pb-6 w-full">

          <Outlet />
        </main>

        <MobileNav />
        <SignalPopup onSignalClick={handleSignalClick} />
      </div>

      {/* Hard paywall — covers every protected route once trial expires. */}
      <TrialExpiredModal />

      {/* PWA install prompt — shown when browser fires beforeinstallprompt */}
      <InstallPrompt />

      {/* Web Push permission prompt — shown when permission is 'default' and browser supports push */}
      <PushPermissionPrompt />
    </div>
  );
}
